<template>
  <div>
    <b-modal
      :title="action === 'add' ? $t('Add Holiday') : $t('Update Holiday')"
      size="lg"
      v-model="show"
      @hidden="$emit('hidden')"
      no-close-on-backdrop
      no-close-on-esc
    >
      <ValidationObserver ref="form-add-or-update-holiday">
        <b-row class="my-1">
          <b-col cols="6">
            <validation-provider name="Country" v-slot="{ errors }">
              <b-form-group
                :label="$t('Country')"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="holidayClone.country_id"
                  label="name"
                  :options="countries"
                  :reduce="(value) => value.id"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              name="Name"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-group :label="$t('Name')">
                <b-form-input
                  v-model="holidayClone.name"
                  :state="errors[0] ? false : null"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider
              name="Month"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-group
                :label="$t('Month')"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="holidayClone.month"
                  label="name"
                  :options="months"
                  :reduce="(value) => value.id"
                  @input="getDays"
                  :getOptionLabel="(option) => $t(option.name)"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider
              name="Day"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-group
                :label="$t('Day')"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="holidayClone.day"
                  label="name"
                  :options="days"
                  :reduce="(value) => value.id"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider
              name="Apply to Payroll"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-group :label="$t('Apply to Payroll')">
                <b-form-checkbox
                  v-model="holidayClone.is_apply"
                  name="apply_to_payroll"
                  value="1"
                  unchecked-value="0"
                  :state="errors[0] ? false : null"
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <validation-provider
              name="Status"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-group :label="$t('Status')">
                <b-form-checkbox
                  v-model="holidayClone.status"
                  name="status"
                  value="1"
                  unchecked-value="0"
                  :state="errors[0] ? false : null"
                >
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </ValidationObserver>

      <template #modal-footer>
        <b-button variant="outline-danger" @click="$emit('hidden')">
          {{ $t("Close") }}
        </b-button>

        <b-button variant="outline-success" @click="addOrUpdateHoliday">
          {{ action === "add" ? $t("Add") : $t("Update") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import EmployeesService from "@/views/rrhh/views/employees/services/employee.service.js";
import HolidayService from "@/views/settings/views/payroll/components/holidays/services/holiday.service.js";
import BasicSettingsService from "@/views/settings/views/general/components/basics/services/basics.settings.service.js";

export default {
  props: {
    action: {
      type: String,
      default: "add",
    },
    holiday: {
      type: Object,
      default: () => ({
        id: null,
        country_id: null,
        name: null,
        date: null,
        is_apply: 0,
        status: 0,
      }),
    },
  },
  data() {
    return {
      show: true,
      holidayClone: { ...this.holiday },
      countries: [],
      months: [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
      ],
      days: [],
    };
  },
  async created() {
    this.getCountries();
    this.getDefaultCountry();
    if (this.action === "edit") {
      await this.getHoliday();
    }
  },
  methods: {
    getDays(m = null) {
      const days = [];
      const month = m == null ? this.holidayClone.month : m;
      const year = new Date().getFullYear();
      const daysInMonth = new Date(year, month, 0).getDate();
      for (let i = 1; i <= daysInMonth; i++) {
        days.push({ id: i, name: i });
      }
      this.days = days;
    },

    async getCountries() {
      try {
        const { data } = await EmployeesService.getCountries();
        this.countries = data;
      } catch (error) {
        this.showToastError(error);
      }
    },

    async getDefaultCountry() {
      try {
        const { data } = await BasicSettingsService.getDefaultCountry();
        this.holidayClone.country_id = parseInt(data.data);
      } catch (error) {
        this.showToastError(error);
      }
    },

    async addOrUpdateHoliday() {
      try {
        const isValid = await this.$refs[
          "form-add-or-update-holiday"
        ].validate();

        if (!isValid) return;
        this.addPreloader();
        const { data } = await HolidayService.addOrUpdateHoliday(
          this.holidayClone
        );
        this.showToastSuccess(data.message);
        this.$emit(this.action === "add" ? "stored" : "updated");
      } catch (error) {
      } finally {
        this.removePreloader();
      }
    },

    async getHoliday() {
      try {
        this.addPreloader();
        const { data } = await HolidayService.getHoliday({
          id: this.holidayClone.id,
        });
        data.month = parseInt(data.month);
        this.getDays(data.month);
        data.day = parseInt(data.day);
        this.holidayClone = data;
      } catch (error) {
        this.showToastError(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>